// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat-button[data-v-447a5616]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:55px;height:55px;border-radius:55px;background-color:#ff6352;color:#fff;-webkit-box-shadow:0 5px 14px 0 rgba(0,0,0,.3);box-shadow:0 5px 14px 0 rgba(0,0,0,.3)}", ""]);
// Exports
module.exports = exports;
